import 'react-quill/dist/quill.snow.css';

import { Col, Form, Row, Skeleton } from 'antd';
import dayjs from 'dayjs';
import {
  UpdateEventDetailsDTO,
} from 'features/events/api/events-api.service';
import { useUpdateEventDetails } from 'features/events/use-cases/event-discription-update';
import { useEffect, useState } from 'react';
import { payFormatDate, payFormatDateTime } from 'utils/payload-date-';

import NoImage from '../../../../assets/No_Image_Available.jpg';
import BasicInfoTextEditor from './basic-info-text-editor/basic-info-text-editor';
import DetailsInformationForm from './details-information-form/details-information-form';

// interface EventDescriptionData {
//   EventDescription: string;
//   EventId: number;
//   EventMasterId: string;
//   EventName: string;
//   EventNameAR: string;
//   CategoryId: number;
//   StartDate: string;
//   EndDate: string;
//   EventDate: string;
//   CurrencyId: number;
//   image_url: string;
//   Address: string,
//   AddressLat: string,
//   AddressLong: string,
//   LocationMapURL: string,
//   Venue: string,
//   MedalPrice: number,
//   TShirtPrice: number,
//   DeliveryPrice: number,
//   PhotoPrice: number,
//   RefundInsurance: boolean,
//   RefundProtectValue: number,
//   EventDescriptionAR: string;
// }

interface props {
  id: string;
  data: any;
  refetch: () => void;
}
const BasicContent = ({ id, data, refetch }: props) => {
  const { isLoading, mutate } = useUpdateEventDetails();
  const [code, setCode] = useState<string>('');
  const [arebicDescr, setArebicDescr] = useState<string>('');
  const [disData, setDisData] = useState<any>('');
  const [discriptionEdit, setDiscriptionEdit] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [mainData, setMainData] = useState<any>();

  const formName = "event-all-details"

  const [form] = Form.useForm();
  const onFinish = (values: any) => {

    const payload = getPayload(values);
    mutate(payload, {
      onSuccess: () => {
        setMainData("")
        refetch()
      }
    });
    setEdit(false);
  };

  const getPayload = (values: any) => {
    const payload: UpdateEventDetailsDTO = {
      ...values,
      EventId: id,
      EventMasterId: id,
      StartDate: payFormatDate(values?.StartDate),
      EndDate: payFormatDate(values?.EndDate),
      EventDate: payFormatDateTime(values?.EventDate),
    };

    return payload;
  };


  function decodeHTMLEntities(text: string) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;

    return textArea.value;
  }


  useEffect(() => {
    setMainData(data)
    form.resetFields();
    setCode(decodeHTMLEntities(data?.EventDescription));
    setDisData(decodeHTMLEntities(data?.EventDescription as any));
    setArebicDescr(data?.EventDescriptionAR as any);
    form.setFieldsValue({
      ...mainData,
      StartDate: dayjs(mainData?.StartDate),
      EndDate: dayjs(mainData?.EndDate),
      EventDate: dayjs(mainData?.EventDate),
    });
    const resjson = JSON.stringify(data)
    localStorage.setItem("event_details", resjson)
  }, [data, mainData]);


  // const handleOpenModal = () => {
  //   setDiscriptionEdit(true);
  //   document.body.style.overflow = 'hidden';
  // }

  const handleCloseModal = () => {
    setDiscriptionEdit(false);
    document.body.style.overflow = 'visible';
  }
  // const handleEditCancel = () => {
  //   setMainData("");
  //   setEdit(false);
  //   refetch();
  // }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, [])

  return (

    <>
      <div className='tabcstmbx'>
        <Form
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          onFinish={onFinish}
          disabled={isLoading}
        >
          <Row className='edbx'>
            <Col className='cellbx edbx_clm'>
              <div className='edbxcld'>
                <Row>
                  <Col className='edfromedtr' span={24}>
                    <h3>Event Information</h3>

                    <div className='descrip'>
                      {loading ? <Skeleton.Image active={true} style={{ height: "250px", width: "400px" }} />
                        :
                        <div className='des_img' style={{ backgroundImage: `url(${data?.image_url})`, }}>

                          <img src={data?.image_url}
                            alt=''
                            onError={(e: any) => { e.target.src = NoImage }}
                          />
                        </div>
                      }

                      <div className='des_dtls'>
                        <div className='des_d_head'>
                          <h5>Description</h5>
                          {/* <Button onClick={handleOpenModal} disabled>Edit</Button> */}
                        </div>
                        <div className='des_b' title={disData && new DOMParser().parseFromString(disData, 'text/html').documentElement.textContent}>
                          <p dangerouslySetInnerHTML={{ __html: disData }} />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>

                    {/* <div className='edit_info_btns'>
                      <Form.Item className='button-group'>
                        {!edit ?
                          <Button
                            className='btn'
                            onClick={() => setEdit(true)}
                            disabled
                          >
                            Edit
                          </Button>
                          :
                          <>
                            <Button
                              type='primary'
                              className='btn cancel_btn'
                              onClick={handleEditCancel}
                            >
                              Cancel
                            </Button>

                            <Button
                              className='btn'
                              htmlType='submit'
                              loading={isLoading}
                              disabled
                            >
                              Update
                            </Button>
                          </>

                        }
                      </Form.Item>
                    </div> */}
                    {/* </Form.Item> */}
                    <div className='edfrom'>
                      <DetailsInformationForm edit={edit} form={form} mainData={mainData} />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Form>
      </div >


      <div className={`cstmrightmdl ${discriptionEdit && "show"}`}>
        <BasicInfoTextEditor
          setCode={setCode}
          code={code}
          showModal={discriptionEdit}
          onClose={handleCloseModal}
          id={id}
          fetchEventDiscriptionData={refetch}
          arebicDescr={arebicDescr}
          setArebicDescr={setArebicDescr}
        />
      </div>
    </>
  );
};

export default BasicContent;
